import React from 'react';

const TeamOne = () => {
  return (
    <section className="team-one">
      <div className="container">
        <div className="section-title text-center sec-title-animation animation-style1">
          <div className="section-title__tagline-box">
            <span className="section-title__tagline">Our Volunteer</span>
          </div>
          <h2 className="section-title__title title-animation">Meet the Dedicated <span>Volunteer</span></h2>
        </div>
        <ul className="row list-unstyled">
          <li className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft" data-wow-delay="100ms">
            <div className="team-one__single">
              <div className="team-one__img-box">
                <div className="team-one__img">
                  <img src="assets/images/team/team-1-1.jpg" alt="" />
                </div>
              </div>
              <div className="team-one__content">
                <div className="team-one__title-box">
                  <h3 className="team-one__title"><a href="volunteer-details.html">Ismail Bello</a></h3>
                  <p className="team-one__sub-title">Chairman</p>
                </div>
                <div className="team-one__arrow-and-social">
                  <div className="team-one__arrow">
                    <span className="fas fa-share-alt"></span>
                  </div>
                  <ul className="team-one__social list-unstyled">
                    <li><a href="#"><span className="fab fa-facebook-f"></span></a></li>
                    <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                    <li><a href="#"><span className="fab fa-pinterest-p"></span></a></li>
                    <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </li>

          <li className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft" data-wow-delay="200ms">
            <div className="team-one__single">
              <div className="team-one__img-box">
                <div className="team-one__img">
                  <img src="assets/images/team/team-1-2.jpg" alt="" />
                </div>
              </div>
              <div className="team-one__content">
                <div className="team-one__title-box">
                  <h3 className="team-one__title"><a href="volunteer-details.html">Musa Abdullahi</a></h3>
                  <p className="team-one__sub-title">Manager</p>
                </div>
                <div className="team-one__arrow-and-social">
                  <div className="team-one__arrow">
                    <span className="fas fa-share-alt"></span>
                  </div>
                  <ul className="team-one__social list-unstyled">
                    <li><a href="#"><span className="fab fa-facebook-f"></span></a></li>
                    <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                    <li><a href="#"><span className="fab fa-pinterest-p"></span></a></li>
                    <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </li>

          <li className="col-xl-3 col-lg-6 col-md-6 wow fadeInRight" data-wow-delay="300ms">
            <div className="team-one__single">
              <div className="team-one__img-box">
                <div className="team-one__img">
                  <img src="assets/images/team/team-1-3.jpg" alt="" />
                </div>
              </div>
              <div className="team-one__content">
                <div className="team-one__title-box">
                  <h3 className="team-one__title"><a href="volunteer-details.html">Fatima Abubakar</a></h3>
                  <p className="team-one__sub-title">Program Coordinator</p>
                </div>
                <div className="team-one__arrow-and-social">
                  <div className="team-one__arrow">
                    <span className="fas fa-share-alt"></span>
                  </div>
                  <ul className="team-one__social list-unstyled">
                    <li><a href="#"><span className="fab fa-facebook-f"></span></a></li>
                    <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                    <li><a href="#"><span className="fab fa-pinterest-p"></span></a></li>
                    <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </li>

          <li className="col-xl-3 col-lg-6 col-md-6 wow fadeInLeft" data-wow-delay="200ms">
            <div className="team-one__single">
              <div className="team-one__img-box">
                <div className="team-one__img">
                  <img src="assets/images/team/team-1-2.jpg" alt="" />
                </div>
              </div>
              <div className="team-one__content">
                <div className="team-one__title-box">
                  <h3 className="team-one__title"><a href="volunteer-details.html">Maryam Isah</a></h3>
                  <p className="team-one__sub-title">IT Support</p>
                </div>
                <div className="team-one__arrow-and-social">
                  <div className="team-one__arrow">
                    <span className="fas fa-share-alt"></span>
                  </div>
                  <ul className="team-one__social list-unstyled">
                    <li><a href="#"><span className="fab fa-facebook-f"></span></a></li>
                    <li><a href="#"><span className="fab fa-twitter"></span></a></li>
                    <li><a href="#"><span className="fab fa-pinterest-p"></span></a></li>
                    <li><a href="#"><span className="fab fa-instagram"></span></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default TeamOne;
